import React from 'react';

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

/**
 * Inline recipient summary for the publish/notify confirm dialogs.
 *
 * The backend returns a breakdown ({clients, client_users, client_contacts,
 * marketing, total}) so an admin can see exactly who a "notify" reaches
 * before sending — including the marketing addresses that get no pricing.
 */
export const RecipientBreakdown = ({ count, testId }) => {
  if (count === null || count === undefined) {
    return <b data-testid={testId}>…</b>;
  }
  const c = typeof count === 'number' ? { total: count } : count;
  const total = c.total ?? 0;

  const parts = [];
  if (c.clients) parts.push(plural(c.clients, 'account'));
  if (c.client_users) parts.push(plural(c.client_users, 'team member'));
  if (c.client_contacts) parts.push(plural(c.client_contacts, 'extra contact'));
  if (c.marketing) parts.push(`${c.marketing} marketing`);

  return (
    <span data-testid={testId}>
      <b>{total}</b> recipient{total === 1 ? '' : 's'}
      {parts.length > 0 && (
        <span className="text-gray-500"> ({parts.join(' · ')})</span>
      )}
    </span>
  );
};

export default RecipientBreakdown;
